import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { Transaction, Transfer } from '@kr/models';

import { PayOutRes } from '../models/pay-out.response';

export interface TransferApi {
  getEstimatesTransferInternal(body: Transfer, orgId: number): Observable<Transaction>;
  getEstimatesTransferExternal(body: Transfer, orgId: number): Observable<Transaction>;
  executeTransferInternal(body: Transfer, orgId: number): Observable<PayOutRes>;
  executeTransferExternal(body: Transfer, orgId: number): Observable<PayOutRes>;
}

export const TRANSFER_API = new InjectionToken<TransferApi>('TRANSFER_API ');
